import { useState } from 'react';

export default function Hero() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToChooser = () => {
    const element = document.getElementById('chooser');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const scrollToFAQ = () => {
    const element = document.getElementById('faq');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <section className="relative min-h-screen bg-[#0a1628] overflow-hidden">
      {/* Navigation Header */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a1628]/95 backdrop-blur-sm border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
              <img 
                src="https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/c5fcb1dbae29388464febce36e760d64.png" 
                alt="BullyProof My Life Shield Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <h1 className="text-white font-black text-base sm:text-lg md:text-xl tracking-tight" style={{ fontFamily: "'Oswald', sans-serif" }}>
              BULLY PROOF MY LIFE
            </h1>
          </a>

          {/* Desktop Navigation Links */}
          <div className="hidden lg:flex items-center gap-6">
            <a 
              href="/" 
              className="text-gray-300 hover:text-white font-semibold text-sm transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Home
            </a>
            <a 
              href="/about" 
              className="text-gray-300 hover:text-white font-semibold text-sm transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              My $4,500 Mistake
            </a>
            <button
              onClick={scrollToFAQ}
              className="text-gray-300 hover:text-white font-semibold text-sm transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              FAQ
            </button>
            <button
              onClick={scrollToChooser}
              className="bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold text-sm px-5 py-2.5 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              ACTIVATE MY SHIELD
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-[#0a1628] border-t border-white/5">
            <div className="px-4 py-4 space-y-3">
              <a 
                href="/" 
                className="block text-gray-300 hover:text-white font-semibold text-base py-2 transition-colors duration-300 cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </a>
              <a 
                href="/about" 
                className="block text-gray-300 hover:text-white font-semibold text-base py-2 transition-colors duration-300 cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                My $4,500 Mistake
              </a>
              <button
                onClick={scrollToFAQ}
                className="block w-full text-left text-gray-300 hover:text-white font-semibold text-base py-2 transition-colors duration-300 cursor-pointer"
              >
                FAQ
              </button>
              <button
                onClick={scrollToChooser}
                className="block w-full bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold text-base px-6 py-3 rounded-lg transition-all duration-300 cursor-pointer text-center"
              >
                ACTIVATE MY SHIELD
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(220, 38, 38, 0.15) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-24 pt-20 sm:pt-24">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          {/* Left Side - Content */}
          <div className="space-y-4 sm:space-y-5">
            {/* Eyebrow */}
            <div className="inline-block">
              <div className="bg-[#FFD700]/10 border border-[#FFD700] rounded-full px-4 py-1.5">
                <p className="text-[#FFD700] font-black text-xs sm:text-sm uppercase tracking-wider">
                  THE "RICH GUY" LEGAL LOOPHOLE
                </p>
              </div>
            </div>

            {/* Main Headline */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-tight" style={{ fontFamily: "'Roboto', sans-serif" }}>
              <span className="text-white">WALK THROUGH LIFE</span>
              <br />
              <span className="text-white">WITH A</span>
              <br />
              <span className="text-[#DC2626]">ROTTWEILER</span>
              <br />
              <span className="text-white">ON A LEASH.</span>
            </h1>

            {/* SEO H2 - Primary Keyword */}
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-200 leading-relaxed">
              Affordable legal protection for homeowners and landlords.
            </h2>

            {/* Subheadline */}
            <p className="text-base sm:text-lg md:text-xl text-gray-300 leading-relaxed max-w-xl">
              For <span className="text-white font-bold">$30/month</span>, you get the same legal firepower the rich use to make problems disappear.
            </p>

            {/* CTA Button */}
            <div className="space-y-2 pt-2">
              <button
                onClick={scrollToChooser}
                className="inline-flex items-center gap-3 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-black text-base sm:text-lg px-8 py-4 rounded-lg transition-all duration-300 shadow-2xl hover:shadow-[#DC2626]/50 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                START HERE
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              
              {/* Secondary Link */}
              <div>
                <button
                  onClick={scrollToChooser}
                  className="text-gray-400 hover:text-white text-sm underline transition-colors duration-300 cursor-pointer"
                >
                  Already know what you need? Skip to activation.
                </button>
              </div>
            </div>

            {/* Trust Line */}
            <div className="flex items-center gap-3 pt-2">
              <div className="flex -space-x-2">
                <div className="w-8 h-8 rounded-full bg-[#DC2626] border-2 border-[#0a1628] flex items-center justify-center">
                  <i className="ri-shield-check-fill text-white text-sm"></i>
                </div>
                <div className="w-8 h-8 rounded-full bg-[#DC2626] border-2 border-[#0a1628] flex items-center justify-center">
                  <i className="ri-scales-3-fill text-white text-sm"></i>
                </div>
                <div className="w-8 h-8 rounded-full bg-[#DC2626] border-2 border-[#0a1628] flex items-center justify-center">
                  <i className="ri-user-star-fill text-white text-sm"></i>
                </div>
              </div>
              <p className="text-gray-400 text-xs sm:text-sm">
                <span className="text-white font-bold">Trusted by thousands</span> who refuse to be bullied
              </p>
            </div>
          </div>

          {/* Right Side - Visual */}
          <div className="relative hidden md:block">
            <div className="relative w-full h-[350px] lg:h-[500px] rounded-2xl overflow-hidden">
              {/* Shield/Gavel Image */}
              <img 
                src="https://public.readdy.ai/ai/img_res/22c70c47f784f0fc112da6bb3fd4a5f5.jpg"
                alt="Legal Shield Protection"
                className="w-full h-full object-cover object-center"
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-l from-transparent via-[#0a1628]/20 to-[#0a1628]/60"></div>
              
              {/* Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#DC2626]/30 via-transparent to-transparent"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-4 -left-4 bg-gradient-to-br from-[#DC2626] to-[#B91C1C] rounded-xl p-4 shadow-2xl border-2 border-white/10">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-shield-star-fill text-2xl text-white"></i>
                </div>
                <div>
                  <p className="text-white font-black text-xl">$30</p>
                  <p className="text-white/80 text-xs">per month</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0f1d2e] to-transparent"></div>
    </section>
  );
}
